export const storeValue = (name: string, value?: string) => {
    try {
        localStorage.setItem(name, value || "");
    } catch (ex) {
    }
}
export const retrieveValue = (name: string, defaultValue?: string) => {
    defaultValue = defaultValue || "";
    try {
        const result = localStorage.getItem(name);
        if (!result) {
            return defaultValue;
        }
        return result;
    } catch (ex) {
        return defaultValue;
    }
}
export const storeObject = (name: string, value: unknown) => {
    try {
        if (value == null) {
            localStorage.removeItem(name);
            return;
        }
        localStorage.setItem(name, JSON.stringify(value));
    } catch (ex) {
    }
}
export const retrieveObject = (name: string, defaultValue?: unknown) => {
    try {
        const result = localStorage.getItem(name);
        if (result == null) {
            return defaultValue;
        }
        return JSON.parse(result);
    } catch (ex) {
        return defaultValue;
    }
}
export const extractObjectFromCookie = (name: string, defaultValue?: unknown) => {
    const cookie = document.cookie
        .split(";")
        .map(cookie => cookie.split("="))
        .find(([key]) => key.trim() === name);

    if (!cookie) {
        return defaultValue;
    }

    try {
        const cookieValue = JSON.parse(decodeURIComponent(cookie[1]));
        document.cookie = `${name}=; max-age=0`;
        return cookieValue;
    } catch (e: unknown) {
        return defaultValue;
    }
}
